
import { Component, Vue } from 'vue-property-decorator';
import Page from '@/components/Page.vue'

@Component({
  components: {
    Page,
  }
})
export default class HomeView extends Vue {

  get background(): string {
    return this.$vuetify.breakpoint.mdAndUp
      ? '/images/hero.jpg'
      : '/images/hero.jpg';
  }
}
